import NotificationIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import { memo, useState } from "react";
import { NotificationsMenu } from "./NotificationsMenu";
import { useNotifications } from "./useNotifications";

export const HeaderNotifications = memo(() => {
  const { totalUnseenCount, markAllNotificationsAsSeen } = useNotifications();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  async function closeMenu() {
    setAnchorEl(null);
    try {
      await markAllNotificationsAsSeen();
    } catch {
      // ignore
    }
  }
  return (
    <>
      <IconButton
        data-testid="notifications-menu-button"
        sx={{ color: "primary.contrastText" }}
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
      >
        <Badge badgeContent={totalUnseenCount} max={9} color="secondary">
          <NotificationIcon color="inherit" />
        </Badge>
      </IconButton>
      <NotificationsMenu
        anchorEl={anchorEl}
        isOpen={Boolean(anchorEl)}
        onClose={closeMenu}
      />
    </>
  );
});
HeaderNotifications.displayName = "HeaderNotifications";
